// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"4f33c155","386":"8a53fe3e","453":"9971212d","735":"ad95b800","762":"2bd50aea","843":"706bfc7a","845":"f8897548"}[chunkId] + ".chunk.js";
};